import { post } from "@rails/request.js";
import InlineRename from "controllers/admin/massimo/inline_rename_controller";

export default class extends InlineRename {
  static values = { eid: String, readUrl: String };

  connect() {
    if (sessionStorage.getItem("massimo-chat-id") === this.eidValue) {
      this.element.setAttribute("data-active", "");
    }
  }

  // Marks the chat read on an explicit row click. This is a POST (never a GET side effect) precisely so
  // Turbo's hover prefetch — which fires a GET at the row's edit link — can't clear the dot before the
  // click. The frame navigation to the (side-effect-free) edit view happens on the same click.
  markRead() {
    // responseKind turbo-stream so the nav-badge refresh the #read action returns is applied to this
    // page (reliably clearing the nav-card dot, not only via the cable broadcast).
    if (this.hasReadUrlValue) post(this.readUrlValue, { responseKind: "turbo-stream" });
  }

  highlight({ detail: { eid } }) {
    if (eid === this.eidValue) {
      this.element.setAttribute("data-active", "");
    } else {
      this.element.removeAttribute("data-active");
    }
  }
}
